/**
 * AST 기반 자동 생성된 검증 함수
 * 이 파일은 scripts/generate-validators.ts에 의해 자동 생성됩니다.
 * 수동으로 수정하지 마세요.
 * 
 * 생성 시간: 2026-11-05T04:17:10.260Z
 * 소스 파일: src/data/dto/pre-registration-info-response-dto
 */

import type { PreRegistrationInfoResponseDto } from "@/data/dto/pre-registration-info-response-dto";

/**
 * PreRegistrationInfoResponseDto 타입 가드 함수
 * AST 분석을 통해 자동 생성된 최적화된 검증 함수
 */
export function isPreRegistrationInfoResponseDto(input: unknown): input is PreRegistrationInfoResponseDto {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    return false;
  }
  
  const obj = input as Record<string, unknown>;
  
  return (
    typeof obj.patient === "object" && obj.patient !== null && !Array.isArray(obj.patient) &&
typeof (obj.patient as any).screeningId === "string" &&
((obj.patient as any).fullName === undefined || ((obj.patient as any).fullName == null || typeof (obj.patient as any).fullName === "string")) &&
((obj.patient as any).lastName === undefined || ((obj.patient as any).lastName == null || typeof (obj.patient as any).lastName === "string")) &&
((obj.patient as any).firstName === undefined || ((obj.patient as any).firstName == null || typeof (obj.patient as any).firstName === "string")) &&
((obj.patient as any).birthDate === undefined || true) &&
((obj.patient as any).gender === undefined || ((obj.patient as any).gender == null || typeof (obj.patient as any).gender === "string")) &&
((obj.patient as any).memo === undefined || ((obj.patient as any).memo == null || typeof (obj.patient as any).memo === "string")) &&
typeof (obj.patient as any).isDeactivated === "boolean" &&
    typeof obj.guardian === "object" && obj.guardian !== null && !Array.isArray(obj.guardian) &&
typeof (obj.guardian as any).fullName === "string" && (obj.guardian as any).fullName.trim() !== "" &&
typeof (obj.guardian as any).lastName === "string" && (obj.guardian as any).lastName.trim() !== "" &&
typeof (obj.guardian as any).firstName === "string" && (obj.guardian as any).firstName.trim() !== "" &&
typeof (obj.guardian as any).phone === "string" &&
typeof (obj.guardian as any).email === "string" &&
typeof (obj.guardian as any).displayPhone === "string" &&
    typeof obj.uuid === "string"
  );
}

/**
 * PreRegistrationInfoResponseDto 상세 검증 결과 반환 함수
 * 검증 실패 시 상세한 에러 정보를 반환합니다.
 */
export interface IValidation<T> {
  success: boolean;
  data?: T;
  errors?: Array<{ path: string; expected: string; value: unknown }>;
}

export function validatePreRegistrationInfoResponseDto(input: unknown): IValidation<PreRegistrationInfoResponseDto> {
  const errors: Array<{ path: string; expected: string; value: unknown }> = [];
  
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    errors.push({
      path: "",
      expected: "object",
      value: input,
    });
    return {
      success: false,
      errors,
    };
  }
  
  const obj = input as Record<string, unknown>;
  
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      errors.push({ path: "", expected: "object", value: obj });
    } else {
      const objObj = obj as Record<string, unknown>;
      // patient (required)
      if (objObj.patient === undefined) {
        errors.push({ path: "patient", expected: "object", value: undefined });
      } else {
        if (typeof objObj.patient !== "object" || objObj.patient === null || Array.isArray(objObj.patient)) {
          errors.push({ path: "patient", expected: "object", value: objObj.patient });
        } else {
          const objObj_patientObj = objObj.patient as Record<string, unknown>;
          // screeningId (required)
          if (objObj_patientObj.screeningId === undefined) {
            errors.push({ path: "patient.screeningId", expected: "string", value: undefined });
          } else {
            if (typeof objObj_patientObj.screeningId !== "string") {
              errors.push({ path: "patient.screeningId", expected: "string", value: objObj_patientObj.screeningId });
            }
          }
          // fullName (optional)
          if (objObj_patientObj.fullName !== undefined) {
            if (!(objObj_patientObj.fullName == null || typeof objObj_patientObj.fullName === "string")) {
              errors.push({ path: "patient.fullName", expected: "string | null", value: objObj_patientObj.fullName });
            }
          }
          // lastName (optional)
          if (objObj_patientObj.lastName !== undefined) {
            if (!(objObj_patientObj.lastName == null || typeof objObj_patientObj.lastName === "string")) {
              errors.push({ path: "patient.lastName", expected: "string | null", value: objObj_patientObj.lastName });
            }
          }
          // firstName (optional)
          if (objObj_patientObj.firstName !== undefined) {
            if (!(objObj_patientObj.firstName == null || typeof objObj_patientObj.firstName === "string")) {
              errors.push({ path: "patient.firstName", expected: "string | null", value: objObj_patientObj.firstName });
            }
          }
          // birthDate (optional)
          if (objObj_patientObj.birthDate !== undefined) {
          
          }
          // gender (optional)
          if (objObj_patientObj.gender !== undefined) {
            if (!(objObj_patientObj.gender == null || typeof objObj_patientObj.gender === "string")) {
              errors.push({ path: "patient.gender", expected: "string | null", value: objObj_patientObj.gender });
            }
          }
          // memo (optional)
          if (objObj_patientObj.memo !== undefined) {
            if (!(objObj_patientObj.memo == null || typeof objObj_patientObj.memo === "string")) {
              errors.push({ path: "patient.memo", expected: "string | null", value: objObj_patientObj.memo });
            }
          }
          // isDeactivated (required)
          if (objObj_patientObj.isDeactivated === undefined) {
            errors.push({ path: "patient.isDeactivated", expected: "boolean", value: undefined });
          } else {
            if (typeof objObj_patientObj.isDeactivated !== "boolean") {
              errors.push({ path: "patient.isDeactivated", expected: "boolean", value: objObj_patientObj.isDeactivated });
            }
          }
        }
      }
      // guardian (required)
      if (objObj.guardian === undefined) {
        errors.push({ path: "guardian", expected: "object", value: undefined });
      } else {
        if (typeof objObj.guardian !== "object" || objObj.guardian === null || Array.isArray(objObj.guardian)) {
          errors.push({ path: "guardian", expected: "object", value: objObj.guardian });
        } else {
          const objObj_guardianObj = objObj.guardian as Record<string, unknown>;
          // fullName (required)
          if (objObj_guardianObj.fullName === undefined) {
            errors.push({ path: "guardian.fullName", expected: "string", value: undefined });
          } else {
            if (!(typeof objObj_guardianObj.fullName === "string" && objObj_guardianObj.fullName.trim() !== "")) {
              errors.push({ path: "guardian.fullName", expected: "string (non-empty)", value: objObj_guardianObj.fullName });
            }
          }
          // lastName (required)
          if (objObj_guardianObj.lastName === undefined) {
            errors.push({ path: "guardian.lastName", expected: "string", value: undefined });
          } else {
            if (!(typeof objObj_guardianObj.lastName === "string" && objObj_guardianObj.lastName.trim() !== "")) {
              errors.push({ path: "guardian.lastName", expected: "string (non-empty)", value: objObj_guardianObj.lastName });
            }
          }
          // firstName (required)
          if (objObj_guardianObj.firstName === undefined) {
            errors.push({ path: "guardian.firstName", expected: "string", value: undefined });
          } else {
            if (!(typeof objObj_guardianObj.firstName === "string" && objObj_guardianObj.firstName.trim() !== "")) {
              errors.push({ path: "guardian.firstName", expected: "string (non-empty)", value: objObj_guardianObj.firstName });
            }
          }
          // phone (required)
          if (objObj_guardianObj.phone === undefined) {
            errors.push({ path: "guardian.phone", expected: "string", value: undefined });
          } else {
            if (typeof objObj_guardianObj.phone !== "string") {
              errors.push({ path: "guardian.phone", expected: "string", value: objObj_guardianObj.phone });
            }
          }
          // email (required)
          if (objObj_guardianObj.email === undefined) {
            errors.push({ path: "guardian.email", expected: "string", value: undefined });
          } else {
            if (typeof objObj_guardianObj.email !== "string") {
              errors.push({ path: "guardian.email", expected: "string", value: objObj_guardianObj.email });
            }
          }
          // displayPhone (required)
          if (objObj_guardianObj.displayPhone === undefined) {
            errors.push({ path: "guardian.displayPhone", expected: "string", value: undefined });
          } else {
            if (typeof objObj_guardianObj.displayPhone !== "string") {
              errors.push({ path: "guardian.displayPhone", expected: "string", value: objObj_guardianObj.displayPhone });
            }
          }
        }
      }
      // uuid (required)
      if (objObj.uuid === undefined) {
        errors.push({ path: "uuid", expected: "string", value: undefined });
      } else {
        if (typeof objObj.uuid !== "string") {
          errors.push({ path: "uuid", expected: "string", value: objObj.uuid });
        }
      }
    }
  
  if (errors.length === 0 && isPreRegistrationInfoResponseDto(input)) {
    return {
      success: true,
      data: input,
    };
  }
  
  return {
    success: false,
    errors: errors.length > 0 ? errors : [
      {
        path: "",
        expected: "PreRegistrationInfoResponseDto",
        value: input,
      },
    ],
  };
}

/**
 * PreRegistrationInfoResponseDto 검증 후 에러 throw 함수
 * 검증 실패 시 상세한 에러 정보를 포함하여 에러를 throw합니다.
 */
export function assertPreRegistrationInfoResponseDto(input: unknown): PreRegistrationInfoResponseDto {
  const validation = validatePreRegistrationInfoResponseDto(input);
  if (!validation.success) {
    const errorDetails = validation.errors?.map(err => 
      `  - ${err.path}: 예상 타입 ${err.expected}, 실제 값: ${JSON.stringify(err.value)}`
    ).join("\n") || "알 수 없는 오류";
    throw new Error(`[assertPreRegistrationInfoResponseDto] :: 검증 실패: PreRegistrationInfoResponseDto 타입과 일치하지 않습니다\n\n오류 상세:\n${errorDetails}`);
  }
  return validation.data!;
}
